import React from 'react';
import WebBaseLayout from '../../components/weblayouts/WebBaseLayout';

const PrivacyPolicy = () => {
  return (
    <WebBaseLayout>
      <section id="privacy" className="privacy">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>Privacy Policy</h2>
                <p>Last Updated: January 2024</p>
              </div>
              
              <div className="privacy-content">
                <p>At Digitalweb Application Development Limited ("Digitalweb," "we," "our," or "us"), we respect your privacy and are committed to protecting any personal information that you share with us. This Privacy Policy explains how we collect, use, and protect your information when you visit our website or engage with our products and services.</p>
                
                <p>By using our website or services, you agree to the terms outlined in this Privacy Policy.</p>
                
                <h3>1. Information We Collect</h3>
                <p>We may collect the following types of information:</p>
                
                <h4>a. Personal Information</h4>
                <p>Information that identifies you personally, such as:</p>
                <ul>
                  <li>Name, email address, phone number, and company details</li>
                  <li>Account registration or inquiry details</li>
                  <li>Billing or payment information (when applicable)</li>
                </ul>
                
                <h4>b. Non-Personal Information</h4>
                <p>Information automatically collected when you use our website or services, such as:</p>
                <ul>
                  <li>IP address and browser type</li>
                  <li>Device information and operating system</li>
                  <li>Pages visited, access times, and referring websites</li>
                </ul>
                
                <h3>2. How We Use Your Information</h3>
                <p>We use collected information to:</p>
                <ul>
                  <li>Provide, operate, and improve our products and services</li>
                  <li>Communicate with you regarding your inquiries or projects</li>
                  <li>Manage accounts, billing, and customer support</li>
                  <li>Send service-related updates or notifications</li>
                  <li>Comply with legal and regulatory obligations</li>
                </ul>
                <p>We do not sell, rent, or trade your personal information to third parties.</p>
                
                <h3>3. Data Storage and Security</h3>
                <p>We implement appropriate technical and organizational measures to safeguard your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
                <p>Data is stored on secure servers and accessed only by authorized personnel who are bound by confidentiality obligations.</p>
                
                <h3>4. Data Retention</h3>
                <p>We retain personal information only as long as necessary to fulfill the purposes for which it was collected or as required by law. Once no longer needed, data is securely deleted or anonymized.</p>
                
                <h3>5. Cookies and Tracking Technologies</h3>
                <p>Our website may use cookies and similar technologies to enhance user experience, track usage patterns, and improve website performance.</p>
                <p>You can choose to disable cookies through your browser settings, though some site features may not function properly as a result.</p>
                
                <h3>6. Your Rights</h3>
                <p>Depending on applicable data protection laws, you may have the right to:</p>
                <ul>
                  <li>Access and request a copy of your personal data</li>
                  <li>Request correction or deletion of inaccurate or outdated information</li>
                  <li>Withdraw consent where processing is based on consent</li>
                  <li>Object to processing for legitimate reasons</li>
                </ul>
                <p>To exercise these rights, please contact us using the details below.</p>
                
                <h3>7. Links to Other Websites</h3>
                <p>Our website may contain links to external websites. We are not responsible for the privacy practices or content of those third-party sites. We encourage you to review their privacy policies before providing personal information.</p>
                
                <h3>8. Updates to This Policy</h3>
                <p>We may update this Privacy Policy periodically to reflect changes in our practices or for legal reasons. The updated version will be posted on this page with a revised "Last Updated" date.</p>
                
                <h3>9. Contact Information</h3>
                <p>If you have questions or concerns about this Privacy Policy or how we handle your data, please contact us at:</p>
                <p><strong>Digitalweb Application Development Limited</strong></p>
                <p>Email: info@digitalweb247.com<br/>
                Website: www.digitalweb247.com<br/>
                Phone: +2347034107070<br/>
                Address: 8b Ogidi Crescent, Lekki Phase 1, Lagos</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </WebBaseLayout>
  );
};

export default PrivacyPolicy;